var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"btn"},[_c('a',{staticClass:"btn__whatsapp",attrs:{"href":"https://wa.me/17868255986?text=Necesito%20mas%20información","target":"_blank"}},[_c('iconic',{staticClass:"btn__whatsapp--icon",attrs:{"name":"whatsapp"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }